import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { createUseStyles } from 'react-jss'

import SVG from '../SVG/SVG'
import ArrowLink from '../Button/ArrowLink'
import { isClientSide } from '../Common/utils'
import Button from '../Button'

const useStyles = createUseStyles(theme => ({
    header: {
        fontFamily: theme.fontFamily,
        overflowX: 'hidden',
    },
    headerMini: {
        display: 'block',
        '@media (max-width: 1024px)': {
            display: 'none',
        },

        backgroundColor: theme.colors.eggshell,

        '& a': {
            backgroundColor: ' transparent',
            color: theme.colors.warmGrey,
            display: 'inline-block',
            fontSize: 13,
            fontWeight: 'bold',
            letterSpacing: 1,
            lineHeight: '15px',
            padding: '8px 25px',
            textDecoration: 'none',
            textTransform: 'uppercase',
            transition: `background-color 250ms ${theme.animations.bezier}, color 250ms ${theme.animations.bezier}`,

            '&.tel': {
                color: theme.colors.deepsea,
            },

            '&:hover': {
                backgroundColor: theme.colors.silver,
                color: theme.colors.coal,
            },
        },
    },
    headerMiniInner: {
        ...theme.wrappers.standard,
        textAlign: 'right',
        '& > a:last-child': {
            marginRight: -25,
        },
    },
    headerMainInner: {
        ...theme.wrappers.standard,
        // padding: "0 0 0 25px",
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row',
    },
    headerLogo: {
        '& svg': {
            height: '79px',
            maxWidth: 129,
            width: '100%',
        },
    },
    mobileTrigger: {
        display: 'none',
        cursor: 'pointer',
        padding: '2em',
        // padding: 25,
        // flexGrow: 1,
        justifyContent: 'flex-end',
        '@media (max-width: 1024px)': {
            display: 'flex',
        },
    },
    headerNavItems: {
        listStyleType: 'none',
        margin: 0,
        padding: 0,

        '& li:first-child': {
            marginLeft: 0,
        },
    },
    headerNavItem: {
        float: 'left',
        margin: 0,
        padding: 0,
        marginLeft: 20,
    },
    headerNavLink: {
        color: theme.colors.coal,
        display: 'block',
        textAlign: 'center',
        padding: '31px 10px 23px',
        // paddingTop: 31,
        // paddingBottom: 23,
        // paddingLeft: 10,
        // paddingRight: 10,
        textDecoration: 'none',
        borderBottom: '6px solid #fff',
        fontSize: 16,
        lineHeight: '19px',
        textTransform: 'uppercase',
        fontWeight: 500,
        letterSpacing: 1,
        transition: `border-bottom 250ms ${theme.animations.bezier}`,

        '&:hover': {
            borderBottom: `6px solid ${theme.colors.sunflower}`,
        },
        '&.active': {
            borderBottom: `6px solid ${theme.colors.sunflower}`,
        },
    },
    headerNavLinkBooking: {
        borderRadius: theme.borderRadius,
        backgroundColor: theme.colors.yellow,
        color: theme.colors.marine,
        fontSize: 14,
        fontWeight: 'bold',
        letterSpacing: '0.2px',
        lineHeight: 'normal',
        textAlign: 'center',
        display: 'block',
        marginTop: 20,
        paddingRight: 15,
        paddingLeft: 15,
        paddingTop: 11,
        paddingBottom: 11,
        textDecoration: 'none',
        textTransform: 'uppercase',
        transition: `background-color 250ms ${theme.animations.bezier}`,
        '&:hover': {
            backgroundColor: theme.colors.sunflower,
            borderBottom: 'transparent',
        },
    },
    mobileNav: {
        display: 'none',
        position: 'fixed',
        top: 60,
        left: 0,
        width: '100%',
        zIndex: 500,
        padding: 10,
        height: 'calc(100vh - 60px)',
        background: 'white',
        boxSizing: 'border-box',
    },
    mobileNavActive: {
        display: 'flex',
    },
    mobileNavInner: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',

        boxSizing: 'content-box',
        // maxWidth: 250,
        margin: '0 auto',
        padding: '0 25px',
        // position: "sticky",
        // top: 0,
        opacity: 1,
        height: '100%',
        // overflow: "hidden",
        // pointerEvents: "none",
        width: '100%',

        '&.active': {
            // "& div": {
            //   pointerEvents: "all",
            //   overflow: "visible",
            // }
        },
    },
    mobileHeaderMini: {
        boxSizing: 'border-box',
        marginBottom: 25,
        marginTop: '0',
        marginLeft: 'auto',
        marginRight: 'auto',
        // textAlign: "center",
        // width: "100%",
        '& .tel': {
            display: 'none',
        },
        '@media (max-width: 1024px)': {
            '& a:last-child': {
                backgroundColor: theme.colors.deepsea,
            },
        },
    },
    mobileHeaderMiniButtons: {
        marginRight: 15,
        backgroundColor: theme.colors.blue,
        borderRadius: theme.borderRadius,
        color: theme.colors.white,
        display: 'inline-block',
        fontSize: 14,
        fontWeight: 'bold',
        padding: '5px 10px',
        textDecoration: 'none',
        textTransform: 'uppercase',
        transition: `background-color 250ms ${theme.animations.bezier}`,

        '&:hover': {
            backgroundColor: theme.colors.deepsea,
        },
    },
    mobileNavItems: {
        listStyle: 'none',
        padding: '0',
        margin: '0',
    },
    mobileHeaderNavLink: {
        borderLeft: `6px solid ${theme.colors.white}`,
        color: theme.colors.blue,
        cursor: 'pointer',
        display: 'inline-block',
        fontSize: 18,
        fontWeight: 500,
        left: -27,
        letterSpacing: 1.13,
        lineHeight: 'normal',
        marginBottom: 4,
        paddingBottom: 10,
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 10,
        position: 'relative',
        textDecoration: 'none',
        textTransform: 'uppercase',
        transition: `border-left 250ms ${theme.animations.bezier}`,
        width: '100%',

        '&:hover': {
            borderLeft: `6px solid ${theme.colors.sunshine}`,
        },
        '&.active': {
            borderLeft: `6px solid ${theme.colors.sunshine}`,
        },
    },
    mobileNavBooking: {
        marginTop: 20,
    },
    mobileNavContact: {
        marginTop: 30,
    },
    headerNavWrapper: {
        display: 'block',
        '@media (max-width: 1024px)': {
            display: 'none',
        },
    },
}))

const Header = ({
    menuLinkManageText,
    menuLinkManageHref,
    menuLinkPhoneText,
    menuLinkPhoneAltText,
    menuLinkPhoneHref,
    menuLinkContactText,
    menuLinkContactHref,
    menuLinks,
}) => {
    const classes = useStyles()
    const [active, setActiveState] = useState(false)

    function toggleMenu() {
        const newState = !active
        if (isClientSide) {
            document.querySelector('body').style.overflowY = newState ? 'hidden' : 'auto'
        }
        setActiveState(newState)
    }

    const mobileClasses = active
        ? `${classes.mobileNav} ${classes.mobileNavActive}`
        : classes.mobileNav

    return (
        <header className={classes.header}>
            <div className={classes.headerMini}>
                <div className={classes.headerMiniInner}>
                    <a href="/driving-safety" style={{ cursor: 'pointer' }}>
                        Driving Safety
                    </a>
                    <a href={menuLinkContactHref}>{menuLinkContactText}</a>
                    <a href={menuLinkPhoneHref} className={'tel'}>
                        {menuLinkPhoneText}
                    </a>
                </div>
            </div>
            <div className={classes.headerMain}>
                <div className={classes.headerMainInner}>
                    <div className={classes.headerLogo}>
                        <a href="/">
                            <SVG name={'AceLogo'} width={189} height={37} />
                        </a>
                    </div>

                    <div className={classes.headerNavWrapper}>
                        <nav className={classes.headerNav}>
                            <ul className={classes.headerNavItems}>
                                {menuLinks.map((link, index) => (
                                    <li
                                        key={`header-menu-link-${index}`}
                                        className={classes.headerNavItem}
                                    >
                                        <a
                                            href={link.href}
                                            className={`${classes.headerNavLink} ${
                                                link.class ? link.class : ''
                                            }`}
                                        >
                                            {link.text}
                                        </a>
                                    </li>
                                ))}

                                <li className={classes.headerNavItem}>
                                    <a
                                        className={classes.headerNavLinkBooking}
                                        href={menuLinkManageHref}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        {menuLinkManageText}
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div className={mobileClasses}>
                        <div className={classes.mobileNavInner}>
                            <div className={classes.mobileHeaderMini}>
                                <a
                                    className={classes.mobileHeaderMiniButtons}
                                    href="/driving-safety"
                                    style={{ cursor: 'pointer' }}
                                >
                                    Driving Safety
                                </a>
                                <a
                                    href={menuLinkPhoneHref}
                                    className={classes.mobileHeaderMiniButtons}
                                >
                                    {menuLinkPhoneAltText}
                                </a>
                            </div>
                            <nav>
                                <ul className={classes.mobileNavItems}>
                                    {menuLinks.map((link, index) => (
                                        <li
                                            key={`header-menu-mobile-link-${index}`}
                                            className={classes.mobileNavItems}
                                        >
                                            <a
                                                href={link.href}
                                                className={`${classes.mobileHeaderNavLink} ${
                                                    link.class ? link.class : ''
                                                }`}
                                            >
                                                {link.text}
                                            </a>
                                        </li>
                                    ))}

                                    <li
                                        className={`${classes.mobileNavItems} ${classes.mobileNavBooking}`}
                                    >
                                        <Button fluid={false} href={menuLinkManageHref}>
                                            {menuLinkManageText}
                                        </Button>
                                    </li>
                                    <li
                                        className={`${classes.mobileNavItems} ${classes.mobileNavContact}`}
                                    >
                                        <ArrowLink href={menuLinkContactHref}>
                                            {menuLinkContactText}
                                        </ArrowLink>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                    <div className={classes.mobileTrigger} onClick={toggleMenu}>
                        {active ? (
                            <SVG name={'Cross'} width={15} height={15} colorOne={'#01396c'} />
                        ) : (
                            <SVG name={'Menu'} width={15} height={15} colorOne={'#01396c'} />
                        )}
                    </div>
                </div>
            </div>
        </header>
    )
}

Header.propTypes = {
    menuLinkManageText: PropTypes.string,
    menuLinkManageHref: PropTypes.string,

    menuLinkPhoneText: PropTypes.string,
    menuLinkPhoneAltText: PropTypes.string,
    menuLinkPhoneHref: PropTypes.string,

    menuLinkContactText: PropTypes.string,
    menuLinkContactHref: PropTypes.string,

    menuLinks: PropTypes.arrayOf(
        PropTypes.shape({
            href: PropTypes.string,
            text: PropTypes.string,
            class: PropTypes.node,
        }),
    ),
}

export default Header
